import { flexRender } from "@tanstack/react-table";

export default function TableBody({ table, columns, loading }) {
  if (loading) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columns.length}
            style={{ padding: "150px", textAlign: "center" }}
          >
            Nalaganje...
          </td>
        </tr>
      </tbody>
    );
  }

  if (table.getRowModel().rows.length === 0) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columns.length}
            style={{ padding: "150px", textAlign: "center", color: "#777" }}
          >
            Ni podatkov za prikaz nove podatke.
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {table.getRowModel().rows.map((row) => (
        <tr key={row.id} style={{ borderBottom: "1px solid #f2f2f2" }}>
          {row.getVisibleCells().map((cell) => (
            <td data-label={cell.column.columnDef.header} key={cell.id}>
              {flexRender(
                cell.column.columnDef.cell ?? cell.getValue(),
                cell.getContext(),
              )}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
